// extracted by mini-css-extract-plugin
export default {"indexCard":"IndexCard-module__indexCard__Pm9Cm4F"};